export default "__VITE_ASSET__BESCex78__"